// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"98308ff2359089abacc0","655":"ecd96f4bdb27364db67e"}[chunkId] + ".js";
};